<div class="avatar-wrapper" *ngIf="!clickHandler" [ngClass]="{disabled: disabled, noFillParent: noFill}">
  <img class="avatar missing" *ngIf="url" [ngClass]="{fullImage: fullImage, noFill: noFill}" [src]="url"
    (load)="$event.target.classList.remove('missing');" (error)="$event.target.classList.add('missing');" />
  <div class="avatar" [ngClass]="getColor(text) + (imageLoading ? ' skeleton-animation' : '')">
    {{imageLoading ? '' : ((text && text.length > 0 ) ? text[0] : '')}}
  </div>
  <div class="background" *ngIf="forceBackground" [ngClass]="getColor(text)"></div>
</div>
<button mat-button class="avatar-wrapper" [ngClass]="{noFillParent: noFill}" *ngIf="clickHandler != null"
  (click)="clickHandler()" [disabled]="disabled">
  <img class="avatar missing" *ngIf="url" [ngClass]="{fullImage: fullImage, noFill: noFill}" [src]="url"
    (load)="$event.target.classList.remove('missing');" />
  <div class="avatar" [ngClass]="getColor(text) + (imageLoading ? ' skeleton-animation' : '')">
    {{imageLoading ? '' : ((text && text.length > 0 ) ? text[0] : '')}}
  </div>
  <div class="background" *ngIf="forceBackground" [ngClass]="getColor(text)"></div>
</button>